import api from './api';

export const contactService = {
   getAll: ({ page = 1, limit = 20 } = {}) => api.get('/contact', { params: { page, limit } }),

   updateStatus: (id, status) => api.patch(`/contact/${id}/status`, { status }),

   delete: (id) => api.delete(`/contact/${id}`),
};
